import React from 'react';

const DocsSVG = () => {
  return (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.800049 3.5C0.800049 1.84315 2.14319 0.5 3.80005 0.5H6.58662C6.85847 0.5 7.12659 0.563294 7.36974 0.68487C8.44642 1.22321 9.40888 1.96463 10.2041 2.8683L10.6147 3.33482C10.9919 3.76352 11.2 4.31501 11.2 4.88608V10.5C11.2 12.1569 9.8569 13.5 8.20005 13.5H3.80005C2.1432 13.5 0.800049 12.1569 0.800049 10.5V3.5ZM8.20005 12.1H3.80005C2.91639 12.1 2.20005 11.3837 2.20005 10.5V3.5C2.20005 2.61634 2.91639 1.9 3.80005 1.9H5.30005V3C5.30005 4.49117 6.50888 5.7 8.00005 5.7H9.80005V10.5C9.80005 11.3837 9.0837 12.1 8.20005 12.1ZM9.59721 4.3C9.58644 4.28629 9.57526 4.27286 9.56368 4.25971L9.15314 3.79319C8.4771 3.02498 7.65892 2.39471 6.74364 1.93707C6.7295 1.93 6.71493 1.92391 6.70005 1.91883V3C6.70005 3.71797 7.28208 4.3 8.00005 4.3H9.59721Z"
        fill="#969FA8"
      />
    </svg>
  );
};

export default DocsSVG;
